import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hidden lg:flex items-center justify-center gap-4 pt-2 select-none"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "flex items-center space-x-1.5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]

import {computed, nextTick, onMounted, onUnmounted, ref, watch} from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'sidebarNavigation',
  props: {
    total: {},
    modelValue: {},
    container: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const displayDots = computed(() => {
  const total = props.total;
  if (total === 0) return [];

  let maxToShow = 5;
  const currentIndex = props.modelValue;

  if (currentIndex === 0 || currentIndex === total - 1) {
    maxToShow = Math.min(total, 3);
  } else if (currentIndex === 1 || currentIndex === total - 2) {
    maxToShow = Math.min(total, 4);
  } else {
    maxToShow = Math.min(total, 5);
  }

  let start = currentIndex - Math.floor(maxToShow / 2);
  if (start < 0) start = 0;
  if (start + maxToShow > total) start = total - maxToShow;

  const dots = [];
  for (let i = 0; i < maxToShow; i++) {
    if (start + i < total) {
      dots.push(start + i);
    }
  }
  return dots;
});

const prev = () => {
  if (props.modelValue > 0) {
    emit('update:modelValue', props.modelValue - 1)
  }
}

const next = () => {
  if (props.modelValue < props.total - 1) {
    emit('update:modelValue', props.modelValue + 1)
  }
}

const goTo = (index: number) => {
  emit('update:modelValue', index)
}

const isOverflowing = ref(true)

const checkOverflow = () => {
  if (props.container) {
    isOverflowing.value = props.container.scrollWidth > props.container.clientWidth
  }
}

let resizeObserver: ResizeObserver | null = null

watch(() => props.container, (newContainer) => {
  if (resizeObserver) {
    resizeObserver.disconnect()
  }
  if (newContainer && typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(() => {
      checkOverflow()
    })
    resizeObserver.observe(newContainer)
  }
  checkOverflow()
}, {immediate: true})

watch(() => [props.total, props.modelValue], () => {
  nextTick(checkOverflow)
})

onMounted(() => {
  window.addEventListener('resize', checkOverflow)
  nextTick(checkOverflow)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkOverflow)
  if (resizeObserver) {
    resizeObserver.disconnect()
  }
})

return (_ctx: any,_cache: any) => {
  return (__props.total > 1 && isOverflowing.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          onClick: prev,
          disabled: __props.modelValue === 0,
          class: "p-1 text-gray-400 hover:text-black disabled:opacity-20 transition-all duration-300 hover:scale-110 active:scale-95",
          type: "button"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "2.5",
            stroke: "currentColor",
            class: "w-3 h-3"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M15.75 19.5L8.25 12l7.5-7.5"
            })
          ], -1)
        ]))], 8, _hoisted_2),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayDots.value, (i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: i,
              class: _normalizeClass(["w-1.5 h-1.5 rounded-full shadow-sm transition-all duration-300", i === __props.modelValue ? 'bg-black ring-2 ring-gray-300 scale-125' : 'bg-black/30 hover:bg-black/50']),
              onClick: ($event: any) => (goTo(i)),
              type: "button"
            }, null, 10, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("button", {
          onClick: next,
          disabled: __props.modelValue === __props.total - 1,
          class: "p-1 text-gray-400 hover:text-black disabled:opacity-20 transition-all duration-300 hover:scale-110 active:scale-95",
          type: "button"
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "2.5",
            stroke: "currentColor",
            class: "w-3 h-3"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M8.25 4.5l7.5 7.5-7.5 7.5"
            })
          ], -1)
        ]))], 8, _hoisted_5)
      ]))
    : _createCommentVNode("", true)
}
}

})